// extracted by mini-css-extract-plugin
export default {"img":"logo-module__img--eE3OA"};